module.exports = __webpack_public_path__ + "img/05.62025ec5.jpg";